import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'userConfirmationPending',
    standalone: false
})
export class UserConfirmationPendingPipe implements PipeTransform {
    transform(members) {
        return members.filter(
            (member) => member.membershipStatus === 'USER_CONFIRMATION_PENDING'
        );
    }
}
